// Central, editable settings for the website. Leave a value as "" until it is confirmed;
// the site will show a clearly labeled "Pending" placeholder instead of inventing information.

export const SITE = {
  name: "First Responders Foundation",
  // Production domain (e.g. "https://www.example.org"). Enables canonical URLs and Open Graph URLs.
  siteUrl: "https://frf-pbc.org",
  // Main Zeffy donation page used by the header, footer, and general Donate buttons.
  donateUrl: "https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7979",
  // Zeffy link for monthly giving. Falls back to donateUrl.
  monthlyDonateUrl: "https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7979",
  donateLinks: {
    serviceDog: "https://www.zeffy.com/en-US/donation-form/donate-to-change-two-lives",
    canteen: "https://www.zeffy.com/en-US/donation-form/canteen-and-rehab",
    general: "https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7979",
  },
  contact: {
    email: "dwight@firstresponders-pbc.org",
    phone: "561-722-3224",
    mailingAddress: "294 Knotty Wood Lane, Wellington, Florida 33414",
    checkPayableTo: "First Responders Foundation",
  },
  social: [
    { label: "Facebook", url: "" },
    { label: "Instagram", url: "" },
    { label: "LinkedIn", url: "" },
    { label: "YouTube", url: "" },
  ],
  nonprofit: {
    status: "a 501(c)(3) nonprofit organization",
    ein: "38-4275167",
    taxDeductibility: "Contributions are tax-deductible to the extent allowed by law.",
    stateRegistration: "CH72758",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Service Dog Program", to: "/service-dog-program" },
  { label: "Our Programs", to: "/programs" },
  { label: "Our Impact", to: "/impact" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "News & Events", to: "/news" },
  { label: "About & Contact", to: "/about" },
];

// Replace any image by dropping a new file into /public/images and updating "src", "alt" and "caption".
export const IMAGES = {
  hero: { src: "/images/fire-scene-greenacres.jpg", mobile: "/images/fire-scene-greenacres-900.jpg", alt: "A Greenacres firefighter carrying an air cylinder past Greenacres Fire Rescue Engine 94, with Palm Beach County Fire Rescue apparatus behind", position: "38% 55%", caption: "Greenacres Fire Rescue and Palm Beach County Fire Rescue apparatus on scene" },
  fireScene: { src: "/images/fire-scene-greenacres-900.jpg", alt: "A Greenacres firefighter carrying an air cylinder past Greenacres Fire Rescue Engine 94, with Palm Beach County Fire Rescue apparatus behind", position: "35% 55%", caption: "Greenacres Fire Rescue and Palm Beach County Fire Rescue apparatus on scene" },
  luna: { src: "/images/luna-harness.jpg", alt: "Luna, the Foundation's ambassador dog, sitting in her working harness and looking up at her handler", position: "40% 35%" },
  lunaResting: { src: "/images/luna-resting.jpg", alt: "Luna resting on her raised dog cot at home", position: "35% 50%" },
  logo: { src: "/images/frf-logo-640.webp", small: "/images/frf-logo-200.webp", alt: "First Responders Foundation, Palm Beach County, logo featuring Luna" },
};

export const donateHref = (monthly = false) =>
  (monthly && SITE.monthlyDonateUrl) || SITE.donateUrl || "/get-involved#donate";
